import React from "react";
import { FiX, FiAlertCircle, FiCheckCircle, FiInfo } from "react-icons/fi";
import "../styles/quotation-system.css";

export default function Modal({ isOpen, onClose, title, message, type = "info", onConfirm, confirmText = "OK", cancelText = "Cancel", showCancel = false }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return <FiCheckCircle size={32} style={{ color: "#10b981" }} />;
      case "error":
        return <FiAlertCircle size={32} style={{ color: "#ef4444" }} />;
      case "warning":
        return <FiAlertCircle size={32} style={{ color: "#f59e0b" }} />;
      default:
        return <FiInfo size={32} style={{ color: "#06b6d4" }} />;
    }
  };

  const getButtonStyle = (isPrimary = true) => {
    if (isPrimary) {
      if (type === "error") {
        return {
          background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
          color: "white",
          border: "none"
        };
      } else if (type === "success") {
        return {
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          color: "white",
          border: "none"
        };
      } else {
        return {
          background: "var(--gradient-primary)",
          color: "white",
          border: "none"
        };
      }
    } else {
      return {
        background: "transparent",
        color: "var(--neutral-700)",
        border: "2px solid var(--neutral-300)"
      };
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        animation: "fadeIn 0.2s ease-out",
        padding: "1rem",
        pointerEvents: "auto",
        isolation: "isolate"
      }}
      onClick={handleBackdropClick}
    >
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "2rem",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          animation: "modalSlideIn 0.3s ease-out",
          position: "relative",
          zIndex: 100000,
          pointerEvents: "auto",
          isolation: "isolate"
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "var(--neutral-500)",
            padding: "0.75rem",
            minWidth: "44px",
            minHeight: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            transition: "all 0.2s",
            touchAction: "manipulation"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(0, 0, 0, 0.05)";
            e.currentTarget.style.color = "var(--neutral-700)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "var(--neutral-500)";
          }}
        >
          <FiX size={20} />
        </button>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem", marginTop: "0.5rem" }}>
          <div style={{ 
            width: "64px", 
            height: "64px", 
            borderRadius: "50%", 
            background: type === "success" 
              ? "rgba(16, 185, 129, 0.1)" 
              : type === "error" 
              ? "rgba(239, 68, 68, 0.1)" 
              : type === "warning"
              ? "rgba(245, 158, 11, 0.1)"
              : "rgba(6, 182, 212, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {getIcon()}
          </div>

          {title && (
            <h3 style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "var(--primary-deep)",
              margin: 0,
              textAlign: "center"
            }}>
              {title}
            </h3>
          )}

          <p style={{
            fontSize: "1rem",
            color: "var(--neutral-600)",
            margin: 0,
            textAlign: "center",
            lineHeight: "1.6"
          }}>
            {message}
          </p>

          <div style={{
            display: "flex",
            gap: "0.75rem",
            width: "100%",
            marginTop: "0.5rem"
          }}>
            {showCancel && (
              <button
                onClick={onClose}
                className="btn-elegant btn-elegant-secondary"
                style={{
                  flex: 1,
                  padding: "0.75rem 1.5rem",
                  minHeight: "48px",
                  touchAction: "manipulation",
                  ...getButtonStyle(false)
                }}
              >
                {cancelText}
              </button>
            )}
            <button
              onClick={handleConfirm}
              className="btn-elegant"
              style={{
                flex: 1,
                padding: "0.75rem 1.5rem",
                fontWeight: "600",
                minHeight: "48px",
                touchAction: "manipulation",
                ...getButtonStyle(true)
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

